// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';
import { transparentize } from 'polished';

export const AlertContainer = styled.div`
    background-color: ${({ error, success, theme, warning }) => {
        const colorMap = new Map([
            [true, theme.infoColor],
            [error, theme.error],
            [success, theme.successColor],
            [warning, theme.warningColor]
        ]);
        return colorMap.get(true);
    }};
    color: ${({ theme }) => theme.white};
    display: flex;
    min-height: 3rem;
    border-radius: 2px;

    & a {
        color: ${props => props.theme.white};
        text-decoration: underline;
    }
`;

export const IconContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 0 0 3rem;
    justify-content: center;
`;

export const Message = styled.div`
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    padding-left: 1rem;
`;

export const Close = styled.button`
    align-items: center;
    background: transparent;
    border: none;
    color: ${props => props.theme.white};
    cursor: pointer;
    display: flex;
    flex: 0 0 3rem;
    justify-content: center;
    padding: 0;

    &:hover,
    &:focus {
        background: ${props => transparentize(0.5, props.theme.white)};
    }

    &:active {
        background: ${props => transparentize(0.7, props.theme.white)};
    }
`;

const iconSize = '1.333333rem';
export const AlertIcon = styled(SVGIcon)`
    height: ${iconSize};
    width: ${iconSize};

    & g {
        fill: ${props => props.theme.white};
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/alert/styles.js